import React from 'react';

export default class History extends React.Component {
    constructor() {
        super();
        this.state = {
            history: [],
            current: -1
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(null);
    }

    addStep(element) {
        const history = this.state.history;
        const current = this.state.current;

        if (current < history.length - 1) {
            history.length = current + 1;
        }

        history.push(JSON.parse(JSON.stringify(element)));
        this.setState({
            history: history,
            current: history.length - 1
        })
    }

    undo() {
        if (!this.canUndo()) {
            return;
        }
        this.setState({current: this.state.current - 1});
    }

    getUndoState() {
        if (!this.canUndo()) {
            return false;
        }
        return this.state.history[this.state.current - 1];
    }

    redo() {
        if (!this.canRedo()) {
            return;
        }
        this.setState({current: this.state.current + 1});
    }

    getRedoState() {
        if (!this.canRedo()) {
            return false;
        }
        return this.state.history[this.state.current + 1];
    }

    canUndo = () => this.state.current > 0;

    canRedo = () => this.state.current < this.state.history.length - 1;

    render() {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/History.js